import { render, staticRenderFns } from "./programPackBookPage.vue?vue&type=template&id=134c779d&scoped=true&"
import script from "./programPackBookPage.vue?vue&type=script&lang=ts&"
export * from "./programPackBookPage.vue?vue&type=script&lang=ts&"
import style0 from "./programPackBook.css?vue&type=style&index=0&id=134c779d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c779d",
  null
  
)

export default component.exports